import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { LanguageProvider } from '@/contexts/language-context'
import { Header } from '@/components/layout/header'
import { Footer } from '@/components/layout/footer'
import HomePage from '@/pages/home'
import ProductsPage from '@/pages/products'
import AboutPage from '@/pages/about'
import ContactPage from '@/pages/contact'
import BlogPage from '@/pages/blog'
import BlogDetailPage from '@/pages/blog-detail'
import { StructuredData } from '@/components/structured-data'

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <StructuredData />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  )
}

export default App
